var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 12L8.7 8.1C8.51667 7.91667 8.425 7.68333 8.425 7.4C8.425 7.11667 8.51667 6.88333 8.7 6.7C8.88333 6.51667 9.11667 6.425 9.4 6.425C9.68333 6.425 9.91667 6.51667 10.1 6.7L14.7 11.3C14.8 11.4 14.8667 11.5083 14.9 11.625C14.95 11.7417 14.975 11.8667 14.975 12C14.975 12.1333 14.95 12.2583 14.9 12.375C14.8667 12.4917 14.8 12.6 14.7 12.7L10.1 17.3C9.91667 17.4833 9.68333 17.575 9.4 17.575C9.11667 17.575 8.88333 17.4833 8.7 17.3C8.51667 17.1167 8.425 16.8833 8.425 16.6C8.425 16.3167 8.51667 16.0833 8.7 15.9L12.6 12Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rightIcon.17575d1c024cfb0fdb8e813bb8e44106.svg";